export enum CompensationConfigRecurrence {
  ONE_OFF = 'ONE_OFF',
  MONTHLY = 'MONTHLY',
}

export enum CompensationConfigTypes {
  ALLOWANCE = 'ALLOWANCE',
  BONUS = 'BONUS',
  COMMISSION = 'COMMISSION',
}

export enum CompensationConfigBonusTypes {
  SIGN_ON_BONUS = 'SIGN_ON_BONUS',
  ANNUAL_BONUS = 'ANNUAL_BONUS',
  CHRISTMAS_BONUS = 'CHRISTMAS_BONUS',
  DEPENDANTS_BONUS = 'DEPENDANTS_BONUS',
  DIRECTOR_BONUS = 'DIRECTOR_BONUS',
  HOLIDAY_BONUS = 'HOLIDAY_BONUS',
  PERFORMANCE_BONUS = 'PERFORMANCE_BONUS',
  REFERAL_BONUS = 'REFERAL_BONUS',
  SENIORITY_BONUS = 'SENIORITY_BONUS',
  BONUS = 'BONUS', // Other Bonus
}

export enum CompensationConfigAllowanceTypes {
  CAR_ALLOWANCE = 'CAR_ALLOWANCE',
  COST_OF_LIVING_ALLOWANCE = 'COST_OF_LIVING_ALLOWANCE',
  EDUCATION_ALLOWANCE = 'EDUCATION_ALLOWANCE',
  END_OF_YEAR_ALLOWANCE = 'END_OF_YEAR_ALLOWANCE',
  HEALTH_ALLOWANCE = 'HEALTH_ALLOWANCE',
  HOLIDAY_ALLOWANCE = 'HOLIDAY_ALLOWANCE',
  HOUSING_ALLOWANCE = 'HOUSING_ALLOWANCE',
  MEAL_ALLOWANCE = 'MEAL_ALLOWANCE',
  PENSION_ALLOWANCE = 'PENSION_ALLOWANCE',
  PHONE_ALLOWANCE = 'PHONE_ALLOWANCE',
  REMOTE_ALLOWANCE = 'REMOTE_ALLOWANCE',
  TRANSPORTATION_ALLOWANCE = 'TRANSPORTATION_ALLOWANCE',
  TRAVEL_ALLOWANCE = 'TRAVEL_ALLOWANCE',
  WELLNESS_ALLOWANCE = 'WELLNESS_ALLOWANCE',
  ALLOWANCE = 'ALLOWANCE', // Other Allowance
}

export enum CompensationSource {
  CONTRACTUAL = 'CONTRACTUAL',
  MONTH_ON_MONTH = 'MONTH_ON_MONTH',
}

export enum CompensationVariantPaymentState {
  REQUESTED = 'REQUESTED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum BulkCompensationType {
  BONUS = 'bonus',
  COMMISSION = 'commission',
  SALARY = 'salary',
}
